import { KeyValue } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { BasketItem, BasketItemType } from '@ecs-services/basket.service';
import { GearOilOverviewService } from '@ecs-services/gear-oil-overview/gear-oil-overview.service';
import { InjectionData, MODAL_CONTENT_TOKEN } from '@ecs-services/modal/modal.helper';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectableRow } from '@os-components';
import { SewButton } from '@sew/ui-components-angular/standalone';
import { Observable, of, switchMap } from 'rxjs';
import { GearOilOverviewTableComponent } from '../gear-oil-overview-table/gear-oil-overview-table.component';

export interface GearOilOverviewTableElement {
    itemNumber: string;
    lubricant: string;
    lubricantType: string;
    viscosity: string;
    formattedCharacteristics: string;
    characteristics: Array<{
        id: string;
        name: string;
    }>;
    size: string;
    formattedApprovedGearbox: string;
    approvedGearbox: Array<{
        id: string;
        name: string;
    }>;
}

@Component({
    selector: 'ecs-gear-oil-overview',
    templateUrl: './gear-oil-overview.component.html',
    styleUrls: ['./gear-oil-overview.component.scss'],
    imports: [SewButton, GearOilOverviewTableComponent, TranslatePipe],
})
export class GearOilOverviewComponent implements OnInit {
    public columns: string[] = [
        'itemNumber',
        'lubricantType',
        'viscosity',
        'characteristics',
        'size',
        'approvedGearbox',
    ];

    public statusFilterValues: KeyValue<string, string>[] = [];

    public showCheckboxColumn = true;
    public rows?: Observable<SelectableRow<GearOilOverviewTableElement>[]>;
    public selectedGearOils: SelectableRow<GearOilOverviewTableElement>[] = [];

    public gearOilOverviewTableElements: GearOilOverviewTableElement[] = [];
    public constructor(
        private gearOilOverviewService: GearOilOverviewService,
        @Inject(MODAL_CONTENT_TOKEN) private injection: InjectionData<string, BasketItem[]>
    ) {}

    public ngOnInit() {
        this.rows = this.gearOilOverviewService.getGearOilOverview().pipe(
            switchMap((data) => {
                const rows: SelectableRow<GearOilOverviewTableElement>[] = [];

                data.forEach((element) => {
                    element.availableSizes.forEach((el) => {
                        rows.push({
                            rowData: {
                                itemNumber: el.partNumber,
                                lubricant: element.lubricant,
                                lubricantType: element.lubricantType,
                                viscosity: element.viscosity,
                                size: `${el.quantity} ${el.unit}`,
                                formattedCharacteristics: element.characteristics
                                    ? element.characteristics.map((char) => char.name).join(', ')
                                    : '',
                                characteristics: element.characteristics ?? [],
                                formattedApprovedGearbox: element.approvedGearbox
                                    ? element.approvedGearbox.map((char) => char.name).join(', ')
                                    : '',
                                approvedGearbox: element.approvedGearbox,
                            },
                            isSelectableRow: true,
                            isDisabled: false,
                        });
                    });
                });

                return of(rows);
            })
        );
    }

    public onRowSelect(event: SelectableRow<GearOilOverviewTableElement>[]) {
        this.selectedGearOils = event;
    }

    public selectGearOils() {
        const selectedOils: BasketItem[] = this.selectedGearOils.map(
            (item) =>
                ({
                    type: BasketItemType.SPARE_PART,
                    productId: item.rowData.itemNumber,
                    quantity: 1,
                }) as BasketItem
        );

        this.injection.close(selectedOils);
    }

    public closeDialog() {
        this.injection.close();
    }
}
